import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import {Store} from "../../../../../../../../services/store.service";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../../../base-error";

@Component({
  selector: "entries-filters",
  templateUrl: "./entries-filters.component.html",
})
export class EntriesFiltersComponent extends BaseError {

  @Input() public filters: any;
  @Input() public serviceId: any;
  @Output() public showLines = new EventEmitter();
  @Output() public hideLines = new EventEmitter();
  @Output() public saveEntriesFilters = new EventEmitter();

  public tempFilters: any;
  public isClosed: boolean = true;

  constructor(public store: Store, toastr: ToastrService) { super(toastr); }

  public ngOnInit(): void {
    this.tempFilters = this.filters;
    if (!this.filters) {
      this.filters = "";
    }
  }

  public open() {
    this.isClosed = false;
    this.hideLines.emit();
  }

  public close() {
    this.isClosed = true;
    this.showLines.emit();
  }

  public save() {
    this.saveEntriesFilters.emit({
      filters: this.filters,
    });
  }

  public updateDeterminantFilter(event) {
    this.filters = JSON.parse(event.jsonString);
  }

  public closeEdit() {
    this.store.state.common.determinantSection.reset();
}

  public get entriesContextLabel(): string | null {
    const determinant = this.store?.state?.common?.determinantSection?.determinant as any;
    if (determinant?.name) {
      return determinant.name;
    }
    if (this.serviceId) {
      return this.serviceId;
    }
    return null;
  }

  public get editDeterminantContextLabel(): string | null {
    const determinant = this.store?.state?.common?.determinantSection?.determinant as any;
    if (determinant?.name) {
      return determinant.name;
    }
    return null;
  }

}
